module.exports = __webpack_public_path__ + "img/review-score.57556ada.png";